// src/mappers/service.mapper.ts
import type { RelatedServiceGroup } from "../models/service_home.model.ts";
import { toBool, toNumber, toNumOrNull, toStrArray } from "../utils/toNumber.ts";

export function normalizeDisplayPrice(dp: any) {
  return {
    // null 은 «가격 미정» — 0 으로 바꾸면 「From ₩0 ~」 이 그려진다.
    price: dp?.price == null ? null : toNumber(dp.price, 0),
    discount_type: (dp?.discount_type ?? null) as any,
    discount_value: dp?.discount_value == null ? null : toNumber(dp?.discount_value, 0),
  };
}

// 서비스 카드 한 장 — 상세의 package·related, 북마크 목록, 제공자 프로필이 같이 쓴다.
export function normalizeServiceCard(s: any) {
  return {
    uuid: String(s?.uuid ?? ""),
    status: toBool(s?.status, false),
    is_coupon_enabled: toBool(s?.is_coupon_enabled ?? s?.is_coupon_enabeld, false),
    is_bookmarked: toBool(s?.is_bookmarked, false),
    profile: {
      name: String(s?.profile?.name ?? ""),
      category_id: toNumber(s?.profile?.category_id, 0),
      category: String(s?.profile?.category ?? ""),
      sub_category_id: toNumber(s?.profile?.sub_category_id, 0),
      sub_category: String(s?.profile?.sub_category ?? ""),
      image: s?.profile?.image == null ? null : String(s.profile.image),
    },
    service_location: { tags: toStrArray(s?.service_location?.tags) },
    service_review: {
      ratings_average: toNumOrNull(s?.service_review?.ratings_average),
      ratings_count: toNumber(s?.service_review?.ratings_count, 0),
    },
    display_price: normalizeDisplayPrice(s?.display_price),
  };
}

export function normalizeRelatedServices(groups: RelatedServiceGroup[] = []): RelatedServiceGroup[] {
  return (groups ?? []).map((g) => ({
    ...g,
    services: (g.services ?? []).map((s: any) => ({
      ...s,
      is_coupon_enabled:
        typeof s.is_coupon_enabled === "boolean"
          ? s.is_coupon_enabled
          : typeof s.is_coupon_enabeld === "boolean"
            ? s.is_coupon_enabeld
            : false,
      display_price: {
        ...s.display_price,
        // null 은 «가격 미정» — 0 으로 바꾸면 홈 카드가 「From Rp0 ~」 을 그린다(검색과 동일 처리).
        price: s?.display_price?.price == null ? null : toNumber(s.display_price.price, 0),
      },
    })),
  }));
}
